import React from 'react';
import Proptypes from 'prop-types';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleIcon from '@material-ui/icons/Check';

const styles = {
  iconContainer: {
    height: '24px',
    width: '24px',
    borderRadius: '12px',
    marginRight: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  error: {
    backgroundColor: 'rgba(233, 102, 133, 0.1)',
    color: 'red',
  },
  success: {
    backgroundColor: 'rgba(48, 199, 140, 0.1)',
    color: 'green',
  },
};

const SeverityIcon = ({ severity }) => {
  switch (severity) {
    case 'error':
      return (
        <div style={{ ...styles.iconContainer, ...styles.error }}>
          <ErrorOutlineIcon fontSize="medium" />
        </div>
      );
    case 'success':
      return (
        <div style={{ ...styles.iconContainer, ...styles.success }}>
          <CheckCircleIcon fontSize="medium" />
        </div>
      );
    default:
      return null;
  }
};

SeverityIcon.propTypes = {
  severity: Proptypes.oneOf(['error', 'success', 'default']),
};

SeverityIcon.defaultProps = {
  severity: '',
};

export default SeverityIcon;
